import React from 'react';

import { KioskType } from 'types/KioskTypes';
import { TimeoutResult } from 'types/common';

import { getUrlParam } from 'utils/urlUtils';
import { openOfflineMode } from 'service/apiElectron';

import { getKioskType, isLocalKiosk } from 'modules/dealers/selectors';

import { useSelector } from '../../hooks';

const ShareboxEmergencyAccess = () => {
  const timer = React.useRef<TimeoutResult>(null);

  const isKiosk = useSelector(isLocalKiosk);
  const kioskType = useSelector(getKioskType);
  const outdoorShareboxToken = getUrlParam('OSToken');

  const displayShareboxEmergencyAccess = (isKiosk && kioskType === KioskType.SHAREBOX) || Boolean(outdoorShareboxToken);

  const handlePressEnd = () => {
    clearTimeout(timer.current);
  };

  const handlePressStart = () => {
    timer.current = setTimeout(() => {
      openOfflineMode();
    }, 5000);
  };

  return displayShareboxEmergencyAccess && (
    <div
      onMouseUp={handlePressEnd}
      onTouchEnd={handlePressEnd}
      onMouseDown={handlePressStart}
      onTouchStart={handlePressStart}
      className="absolute z-max w-16 h-16"
      data-testid="sharebox-emergency-access"
    />
  );
};

export default ShareboxEmergencyAccess;
